import React from 'react'
import PropTypes from 'prop-types'

const InitialView = ({ allowedExports, onExcelClick, onPDFClick, onPhotosClick }) => (
  <div className="export-type">
    <div className="row">
      {allowedExports.includes('excel') ? (
        <div className="col-md-6">
          <div className="card h-100" onClick={onExcelClick}>
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Excel</h4>
                <i className="fas fa-file-excel fa-4x" />
              </div>
              <p className="card-text text-center">
                Exporter les ressources par email au format Excel (.xlsx).
              </p>
            </div>
          </div>
        </div>
      ) : null}
      {allowedExports.includes('pdf') ? (
        <div className="col-md-6">
          <div className="card h-100" onClick={onPDFClick}>
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">PDF</h4>
                <i className="far fa-file-pdf fa-4x" />
              </div>
              <p className="card-text text-center">
                Exporter les ressources par email au format PDF avec filtrage par section.
              </p>
            </div>
          </div>
        </div>
      ) : null}
      {allowedExports.includes('photos') ? (
        <div className="col-md-6">
          <div className="card h-100" onClick={onPhotosClick}>
            <div className="card-body">
              <div className="text-center mb-3">
                <h4 className="card-title">Photos</h4>
                <i className="fas fa-images fa-4x" />
              </div>
              <p className="card-text text-center">
                Télécharger toutes les photos dans un fichier archive (zip).
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  </div>
)

InitialView.propTypes = {
  allowedExports: PropTypes.arrayOf(PropTypes.string).isRequired,
  onExcelClick: PropTypes.func.isRequired,
  onPDFClick: PropTypes.func.isRequired,
  onPhotosClick: PropTypes.func.isRequired
}

export default InitialView